import {
  COLORS_RYGU,
  QUESTION_3,
  ROLE_LIST,
} from "../../constants/constants.js";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Card } from "react-bootstrap";
import LoadingSpinner from "../LoadingSpinner.js";
import { useAPI } from "../../ApiContext.js";
import { PieChartOptions } from "../../constants/BarChartOptions.js";
import { useContext } from "react";
import { ColorPaletteContext } from "../../App.js";
import { getRoleDataQ3 } from "../../Helper.js";

ChartJs.register(
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  annotationPlugin,
  ChartDataLabels
);

function RoleDataPieChartQ3(props) {
  const { dashboardData } = useAPI();
  const colorPaletteContext = useContext(ColorPaletteContext);

  const { colorPaletteState } = colorPaletteContext;

  function getChartData() {
    return {
      labels: ROLE_LIST.map((item) => item.value),
      datasets: [
        {
          label: "Role",
          data: ROLE_LIST.map((item) =>
            getRoleDataQ3(item.key, dashboardData.data, {
              countryFilterValue: props.countryFilterValue,
              roleFilterValue: props.roleFilterValue,
            })
          ),
          borderColor: colorPaletteState,
          backgroundColor: colorPaletteState,
          borderWidth: 1,
          hoverOffset: 4,
        },
      ],
    };
  }

  return (
    <Card>
      <Card.Header>{QUESTION_3}</Card.Header>
      <Card.Body>
        {dashboardData.data && dashboardData.data.length > 0 ? (
          <div style={{ width: "100%", height: "60vh" }}>
            <Pie options={PieChartOptions} data={getChartData()} />
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </Card.Body>
    </Card>
  );
}
export default RoleDataPieChartQ3;
